import * as types from "../actions/actionsTypes";

let initialState = {
  listFormations: [],
};

const formationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_FORMATIONS:
      return {
        ...state,
        listFormations: action.data,
      };

    case types.RESET_FORMATIONS:
      return {
        listFormations: [],
      };

    default:
      return state;
  }
};

export default formationsReducer;
